import React, { useEffect } from 'react'
import { useTranslation } from '@/localization/useTranslation'
import { Spinner } from '@/components/Loading/Spinner'
import { RedirectFormOption, FormOption } from '@/actors/AuthActor/types'
import { Stack } from '@/components/Stack'
import { LayoutType } from '@/actors/AuthActor/types'
import { LAYOUT_TYPE } from '@/constants/auth'
import { resolveNavTarget } from '@/utils/url'

interface RedirectProps {
  handleLayoutTypeChange: (type: LayoutType | null) => void
  form?: FormOption
}

// Type guard to check if form is a RedirectFormOption
const isRedirectForm = (form: FormOption | undefined): form is RedirectFormOption => {
  return form?.type === 'redirect' && 'trigger' in (form || {})
}

export const Redirect: React.FC<RedirectProps> = (props) => {
  const { form, handleLayoutTypeChange } = props
  const { t } = useTranslation()

  useEffect(() => {
    if (isRedirectForm(form) && form.trigger?.action) {
      const target = resolveNavTarget(form.trigger.action)
      if (!target) return
      handleLayoutTypeChange(LAYOUT_TYPE.SINGLE_COLUMN)
      // Short timeout to allow the component to render before redirecting
      const timer = setTimeout(() => {
        window.location.href = target.url
      }, 1500)

      return () => clearTimeout(timer)
    }
  }, [form, handleLayoutTypeChange])

  return (
    <Stack justify='center' align='center' gap='md'>
      <Spinner />
      <h3>{t('You are being redirected')}</h3>
    </Stack>
  )
}
